import React from 'react';
import { GoogleLogo } from './GoogleLogo';

const toKebab = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const includesGoogleReviewCount = (value) => value.toLowerCase().includes('review') && value.includes('700+');

export const HeroProofList = ({ items, testId = 'hero-proof-list' }) => (
  <ul className="list-disc pl-5 space-y-1.5 text-sm text-gray-600 mb-6" data-testid={testId}>
    {items.map((item, index) => (
      <li key={item} className={index === 0 ? 'font-bold text-gray-900 pl-0.5' : 'pl-0.5'} data-testid={`${testId}-item-${toKebab(item)}`}>
        {includesGoogleReviewCount(item) ? (
          <span className="inline-flex items-center gap-1.5" data-testid={`${testId}-google-review-count`}>
            <GoogleLogo className="h-4 w-4 flex-shrink-0" testId={`${testId}-google-logo`} />
            <span>{item}</span>
          </span>
        ) : item}
      </li>
    ))}
  </ul>
);